import type { Tab } from '../store/layoutStore';
import { useLayoutStore } from '../store/layoutStore';
import { TAB_SECTION_SCOPES } from '../store/tabSectionScopes';

export function resetMainContentTabSubTabState({ tab }: { tab: Tab }): void {
  for (const scope of Object.values(TAB_SECTION_SCOPES)) {
    useLayoutStore.getState().clearTabSection({ scope, tabId: tab.id });
  }

  if (tab.type === 'application') {
    useLayoutStore.getState().setEndpointTab('app-overview', 'scoping');
  }
}
